import { authRoles } from '../../../auth/authRoles'
import { OperacionesProvider } from '../../base/contexts/OperacionesContext'
import ArticuloMonedaGestion from './view/ArticuloMonedaGestion'

export const articuloMonedaRoutesMap = {
  gestion: {
    path: '/articuloMoneda/gestion',
    name: 'Monedas del Sistema',
  },
  registro: {
    path: '/articuloMoneda/nuevo',
    name: 'Nuevo Articulo Moneda',
  },
}

/**
 * Estructura de ruta para cargar la página principal
 */
const articuloMonedaRoutes = [
  {
    path: articuloMonedaRoutesMap.gestion.path,
    element: (
      <OperacionesProvider>
        <ArticuloMonedaGestion />
      </OperacionesProvider>
    ),
    auth: authRoles.admin,
  },
  /*{
    path: articuloMonedaRoutesMap.upsert.path,
    element: <Articulo MonedaRegistroApp />,
    auth: authRoles.admin,
  },*/
]

export default articuloMonedaRoutes
